$(function() {
    var className = 'accordion';
    var isOpen = false;
    var scrollDuration = 500;

    $('.js-' + className).each(function() {
        var parent = $(this);
        var title = $(this).find('.' + className + '__title');
        var click = false;

        parent.data({
            fn: {
                open: open,
                close: close,
                closeTab: closeTab,
            }
        });

        title.on('click', function() {
            click = true;

            if (parent.hasClass(className + '--open')) {
                close();
            } else {
                var previousHeight = $('.accordion--open .accordion__wrap').innerHeight();

                $('.' + className).not(parent).each(function() {
                    $(this).data().fn.close();
                });

                // Horrible tab content stuff (when nesting accordion inside tabs)
                $('.tab-content__content').each(function() {
                    $(this).removeClass('tab-content__content--active');
                });

                parent.closest('.tab-content__content').addClass('tab-content__content--active');

                $('.tab-content__tab').each(function() {
                    $(this).removeClass('tab-content__tab--active');
                });

                open(previousHeight);

                var i = $('.accordion--open').parent().index();

                if (i != -1) {
                    parent.closest('.tab-content').find('.tab-content__tab').eq(i).addClass('tab-content__tab--active');
                }
            }
        });

        // if (!isOpen) {
        //     open();
        //     isOpen = true;
        // }

        function close() {
            parent.removeClass('accordion--open');
            $('.accordion__wrap', parent).css('max-height', 0);

            $('.tab-content__tab').each(function() {
                $(this).removeClass('tab-content__tab--active');
            });

            $('.tab-content__content').each(function() {
                $(this).removeClass('tab-content__content--active');
            });
            $('.accordion--open').removeClass('accordion--open');
        }

        function closeTab() {
            parent.removeClass('accordion--open');
            $('.accordion__wrap', parent).css('max-height', 0);

            $(this).find('.tab-content__tab').each(function() {
                $(this).removeClass('tab-content__tab--active');
            });

            $(this).find('.tab-content__content').each(function() {
                $(this).removeClass('tab-content__content--active');
            });

            $('.accordion--open').removeClass('accordion--open');
        }

        function open(previousHeight) {
            parent.addClass('accordion--open');
            var height = $('.accordion__body', parent).outerHeight() + 5;
            $('.accordion__wrap', parent).css('max-height', height + "px");
            if (click) {
                scroll(title, previousHeight);
            }
            click = false;
        }

        function scroll(el, previousHeight) {
            var items = [
                $('.navigation__header'),
                $('.cta-bar'),
                $('#debug-bar'),
                $('#admin-bar')
            ];
            var scrollTop = el.offset().top - 20;

            for (var i = 0; i < items.length; i++) {
                if (items[i].length > 0) {
                    scrollTop -= items[i].height();
                }
            }

            scrollTop -= previousHeight;

            $('html, body').animate({
                scrollTop: scrollTop
            }, {
                duration: scrollDuration
            });
        }

        $(window).on('resize', function() {
            resetHeight();
        });

        function resetHeight() {
            if ($(window).innerWidth() > 750 && $('.js-tab-content').find('.accordion--open').length < $('.js-tab-content').length) {
                parent.closest('.tab-content').find('.tab-content__tab').eq(0).addClass('tab-content__tab--active');

                $('.js-tab-content').each(function() {
                    $(this).find('.accordion').eq(0).addClass('accordion--open');
                });

                $('.tab-content__content').eq(0).addClass('tab-content__content--active');
            }

            if (parent.hasClass('accordion--open')) {
                var height = $('.accordion__body', parent).outerHeight() + 5;
                $('.accordion__wrap', parent).css('max-height', height + "px");
            } else {
                $('.accordion__wrap', parent).css('max-height', '');
            }
        }
    });
});
